/* ForgeMynd: scroll reveal and count-up for fm-* sections. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fm-count'));
    var decimals = parseInt(el.getAttribute('data-fm-decimals') || '0', 10);
    if (isNaN(target)) return;
    if (reduce) { el.textContent = target.toFixed(decimals); return; }
    var start = null;
    var duration = 1400;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (t < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  window.fmReady = true;

  function init(root) {
    var items = (root || document).querySelectorAll('[data-fm-reveal]:not(.is-in), [data-fm-count]:not(.is-counted)');
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-fm-count')) { el.classList.add('is-counted'); countUp(el); }
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-fm-count') && !el.classList.contains('is-counted')) {
          el.classList.add('is-counted');
          countUp(el);
        }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) {
      if (el.hasAttribute('data-fm-count')) el.textContent = (0).toFixed(parseInt(el.getAttribute('data-fm-decimals') || '0', 10));
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
